import { SET_USER, CLEAR_USER } from "./types";

export const setUser = user => dispatch => {
  dispatch({
    type: SET_USER,
    payload: user
  });
  
  // Trigger theme update immediately after setting user data
  // This ensures theme applies based on user preferences without refresh
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('themeUpdate'));
  }
};

export const clearUser = () => dispatch => {
  dispatch({
    type: CLEAR_USER,
    payload: {}
  });
};
